import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { DealAnalysisPageComponent } from './component/deal-analysis-page/deal-analysis-page.component';
import { DealAnalysisRoutingModule } from './deal-analysis-routing.module';

@NgModule({
  declarations: [DealAnalysisPageComponent],
  imports: [
    CommonModule,
    DealAnalysisRoutingModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    NgbModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    NavigationModule,
    MatSortModule,
    MatSelectModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [MatSortModule, DealAnalysisPageComponent],
  entryComponents: [],
})
export class DealAnalysisModule { }
